// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SaintBarthelemy from '../_raw/flag/icon_flag_saint_barthelemy.png';

export default () => <img src={SaintBarthelemy} alt="SaintBarthelemy" />;
